import React, { useMemo } from 'react'

import { useServiceOrder } from '../../../_load/ServiceOrderLoader'
import Separator from '../../../../../../components/pdf/Separator'
import { countReplies } from '../../../_helpers/pdfHelpers'
import View from '../../../../../../components/pdf/View'
import NonComplianceTable from './NonComplianceTable'
import ComplianceTable from './ComplianceTable'

const Result = () => {
  const serviceOrder = useServiceOrder()

  const resumeCounters = useMemo(() => {
    const replies = serviceOrder.replies
    const counters = { affirmativeCount: 0, negativeCount: 0, nonCompliancesCount: 0, ...countReplies(replies) }

    return { ...counters }
  }, [serviceOrder])

  return (
    <View>
      <ComplianceTable counters={resumeCounters} />
      <Separator weight={4} />
      <NonComplianceTable counters={resumeCounters} />
    </View>
  )
}

export default Result
